import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Spinner from '../spinner'
import Typography from '../typography'

import { buildFormData } from './functions'
import { submitForm } from '../../../api/bantrab'

const Form = ({ form, pageId, onFailure, onSuccess, ...attrs }) => {
  const fields = form.formFields
  const [formData, setFormData] = useState(buildFormData(fields))
  const [submitSuccess, setSubmitSuccess] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const updateFormData = (event) => {
    const name = event.target.name
    const value = event.target.value

    const newFormData = { ...formData }
    newFormData[name] = value

    setFormData(newFormData)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (!submitting) {
      setSubmitting(true)

      const data = {
        page: pageId,
        form: form.id,
        formData: JSON.stringify(formData),
        recaptcha: 'asdasdfasd'
      }
      let response = await submitForm(data)

      if (response.ok) {
        setSubmitSuccess(true)
      } else {
        setSubmitSuccess(false)
      }

      response = await response.json()

      setSubmitting(false)
    }
  }

  useEffect(() => {
    if (submitSuccess) {
      onSuccess && onSuccess()
    } else {
      onFailure && onFailure()
    }
  }, [submitSuccess])

  return <form
    className={
      classNames([
        'flex',
        'flex-col',
        'bg-white'
      ])
    }
    method={'POST'}
    onSubmit={handleSubmit}>
    {
      fields.map((field, index) => {
        return <div
          key={index}
          className={'mb-6'}>
          <Typography
            size={'two'}
            className={'mb-2 text-green-500'}>
            {field.label}
          </Typography>

          <input
            name={field.cleanName}
            required={field.required}
            defaultValue={formData[field.cleanName]}
            placeholder={`Ingresa ${field.label.toLowerCase()}`}
            className={
              classNames([
                'flex-grow',
                'py-3',
                'px-6',
                'outline-none',
                'border',
                'border-gray-300',
                'w-full'
              ])
            }
            style={{
              borderRadius: '1.5rem'
            }}
            onChange={updateFormData} />
        </div>
      })
    }
    <button
      type={'submit'}
      className={
        classNames([
          'relative',
          'mt-4',
          'py-3',
          'px-4',
          'bg-green-500',
          'text-white',
          'flex',
          'flex-row',
          'items-center',
          'justify-center',
          'hover:bg-green-400',
          'active:bg-green-600',
          submitting ? 'cursor-not-allowed' : ''
        ])
      }
      style={{
        borderRadius: '0 1.5rem 1.5rem 1.5rem'
      }}
      onClick={handleSubmit}>
      {
        submitting
          ? <Spinner
            color={'white'}
            className={
              classNames([
                'absolute',
                '-top-4',
                '-bottom-4',
                'left-0',
                'rigth-0',
                'w-full'
              ])
            } />
          : null
      }
      <Typography>
        Inscribirme
      </Typography>
    </button>
  </form>
}

Form.propTypes = {
  form: PropTypes.object,
  pageId: PropTypes.number,
  onSuccess: PropTypes.func,
  onFailure: PropTypes.func
}

export default Form
